// import React from "react";
import "./CTASection.css";
import care1Icon from "../assets/icons/care1.svg";
import proc5Icon from "../assets/icons/proc5.svg";
import care3Icon from "../assets/icons/care3.svg";
import badge1Icon from "../assets/icons/badge1.svg";
import badge2Icon from "../assets/icons/badge2.svg";
import badge3Icon from "../assets/icons/badge3.svg";
// import ctaLeaf from "../assets/icons/cta_leaf.svg";
import ctaSun from "../assets/icons/cta_sun.svg";
import btnArrow from "../assets/icons/btn_arrow.svg";
import sectionLabel from "../assets/icons/section_label.svg";

const ongoingFeatures = [
  {
    icon: care1Icon,
    title: "Monthly practitioner-reviewed formula adjustments",
  },
  {
    icon: proc5Icon,
    title: "Personalized herbal shipments",
  },
  {
    icon: care3Icon,
    title: "Ongoing symptom support",
  },
];

const ctaBadges = [
  {
    icon: badge1Icon,
    label: "Licensed Practitioners",
  },
  {
    icon: badge2Icon,
    label: "Personalized Formulas",
  },
  {
    icon: badge3Icon,
    label: "Nationwide Shipping",
  },
];

const CTASection = ({ onGetHerbalPlan }) => {
  return (
    <>
      {/* Ongoing herbal care section */}
      <section className="cta-ongoing-section">
        <div className="cta-ongoing-container">
          <div className="cta-ongoing-header">
            <div className="cta-section-label">
              <img src={sectionLabel} alt="" width="192" height="32" />
            </div>
            <h2 className="cta-ongoing-title">
              Ongoing herbal care, simplified
            </h2>
            <p className="cta-ongoing-subtitle">
              Herbal medicine works best when formulas evolve with your body.
              Hua Shen offers continued monthly support so your formula can be
              refined as symptoms shift and progress builds.
            </p>
          </div>
          <div className="cta-ongoing-cards">
            {ongoingFeatures.map((f, i) => (
              <div className="cta-ongoing-card" key={i}>
                <div className="cta-ongoing-icon">
                  <img src={f.icon} alt="" width="64" height="64" />
                </div>
                <p className="cta-ongoing-card-title">{f.title}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA card section */}
      <section className="cta-section">
        <div className="cta-container">
          <div className="cta-card">
            {/* <img src={ctaLeaf} alt="" className="cta-card-leaf" /> */}
            <img src={ctaSun} alt="" className="cta-card-sun" />
            <h2 className="cta-card-title">
              Ancient medicine.
              <br />
              <em className="cta-card-title-italic">
                Tailored to the individual.
              </em>
            </h2>
            <p className="cta-card-subtitle">
              Begin your custom intake and receive herbal medicine crafted
              specifically for you.
            </p>
            <button className="cta-button" onClick={onGetHerbalPlan}>
              Start your intake
              <img src={btnArrow} alt="" width="20" height="20" />
            </button>
            <div className="cta-divider" />
            <div className="cta-badges">
              {ctaBadges.map((b, i) => (
                <div className="cta-badge" key={i}>
                  <img src={b.icon} alt="" width="48" height="48" />
                  <span>{b.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CTASection;
